export default "__VITE_ASSET__DurjpPWZ__"